export const EventStatusDictionary = {
    LIVE: 'LIVE',
    SCHEDULED: 'SCHEDULED',
    COMING: 'COMING',
    NOW_PLAYING: 'NOW PLAYING'
}